{
  "AUTOMATION": {
    "HEADER": "Automatizácia",
    "DESCRIPTION": "Automatizácia môže nahradiť a zjednodušiť procesy, ktoré vyžadujú manuálnu prácu, napríklad pridávanie štítkov a priraďovanie konverzácií najvhodnejšiemu agentovi. Tím sa tak môže sústrediť na svoje silné stránky a strávi menej času rutinnými úlohami.",
    "LEARN_MORE": "Zistiť viac o automatizácii",
    "HEADER_BTN_TXT": "Pridať automatizačné pravidlo",
    "LOADING": "Načítavajú sa automatizačné pravidlá",
    "ADD": {
      "TITLE": "Pridať automatizačné pravidlo",
      "SUBMIT": "Vytvoriť",
      "CANCEL_BUTTON_TEXT": "Zrušiť",
      "FORM": {
        "NAME": {
          "LABEL": "Názov pravidla",
          "PLACEHOLDER": "Zadajte názov pravidla",
          "ERROR": "Názov je povinný"
        },
        "DESC": {
          "LABEL": "Popis",
          "PLACEHOLDER": "Zadajte popis pravidla",
          "ERROR": "Popis je povinný"
        },
        "EVENT": {
          "LABEL": "Udalosť",
          "PLACEHOLDER": "Vyberte jednu možnosť",
          "ERROR": "Udalosť je povinná"
        },
        "CONDITIONS": {
          "LABEL": "Podmienky"
        },
        "ACTIONS": {
          "LABEL": "Akcie"
        },
        "PHASE": {
          "LABEL": "Fáza"
        },
        "ORDER": {
          "LABEL": "Poradie",
          "ERROR": "Poradie je povinné"
        }
      },
      "CONDITION_BUTTON_LABEL": "Pridať podmienku",
      "ACTION_BUTTON_LABEL": "Pridať akciu",
      "API": {
        "SUCCESS_MESSAGE": "Automatizačné pravidlo bolo úspešne pridané",
        "ERROR_MESSAGE": "Nepodarilo sa vytvoriť automatizačné pravidlo. Skúste to prosím neskôr."
      }
    },
    "LIST": {
      "TABLE_HEADER": {
        "NAME": "Meno",
        "DESCRIPTION": "Popis",
        "ACTIVE": "Aktívne",
        "CREATED_ON": "Vytvorené",
        "PHASE": "Fáza",
        "ORDER": "Poradie",
        "WAIT": "Čakanie"
      },
      "404": "Nenašli sa žiadne automatizačné pravidlá",
      "TABS": {
        "ALL": "Všetko",
        "INSTANT": "Pri udalosti",
        "DELAYED": "S odkladom"
      },
      "WAITS": "Čaká {duration}"
    },
    "DELETE": {
      "TITLE": "Odstrániť automatizačné pravidlo",
      "SUBMIT": "Vymazať",
      "CANCEL_BUTTON_TEXT": "Zrušiť",
      "CONFIRM": {
        "TITLE": "Potvrdiť vymazanie",
        "MESSAGE": "Určite chcete vymazať ",
        "YES": "Áno, vymazať ",
        "NO": "Nie, ponechať "
      },
      "API": {
        "SUCCESS_MESSAGE": "Automatizačné pravidlo bolo úspešne odstránené",
        "ERROR_MESSAGE": "Nepodarilo sa odstrániť automatizačné pravidlo. Skúste to prosím neskôr."
      }
    },
    "EDIT": {
      "TITLE": "Upraviť automatizačné pravidlo",
      "SUBMIT": "Aktualizovať",
      "CANCEL_BUTTON_TEXT": "Zrušiť",
      "API": {
        "SUCCESS_MESSAGE": "Automatizačné pravidlo bolo úspešne aktualizované",
        "ERROR_MESSAGE": "Nepodarilo sa aktualizovať automatizačné pravidlo. Skúste to prosím neskôr."
      }
    },
    "CLONE": {
      "TOOLTIP": "Klonovať",
      "API": {
        "SUCCESS_MESSAGE": "Automatizácia bola úspešne skopírovaná",
        "ERROR_MESSAGE": "Nepodarilo sa skopírovať automatizačné pravidlo. Skúste to prosím neskôr."
      }
    },
    "FORM": {
      "EDIT": "Upraviť",
      "CREATE": "Vytvoriť",
      "DELETE": "Vymazať",
      "CANCEL": "Zrušiť",
      "RESET_MESSAGE": "Zmena typu udalosti vymaže podmienky a akcie, ktoré ste pridali nižšie"
    },
    "CONDITION": {
      "DELETE_MESSAGE": "Na uloženie potrebujete aspoň jednu podmienku",
      "CONTACT_CUSTOM_ATTR_LABEL": "Vlastné atribúty kontaktu",
      "CONVERSATION_CUSTOM_ATTR_LABEL": "Vlastné atribúty konverzácie"
    },
    "ACTION": {
      "DELETE_MESSAGE": "Na uloženie potrebujete aspoň jednu akciu",
      "TEAM_MESSAGE_INPUT_PLACEHOLDER": "Sem zadajte svoju správu",
      "TEAM_DROPDOWN_PLACEHOLDER": "Vyberte tímy",
      "EMAIL_INPUT_PLACEHOLDER": "Zadajte e-mail",
      "URL_INPUT_PLACEHOLDER": "Zadajte URL",
      "SENDER_DROPDOWN_PLACEHOLDER": "Vyberte e-mailovú schránku a adresu odosielateľa",
      "SUBJECT_INPUT_PLACEHOLDER": "Predmet e-mailu",
      "SMS_INBOX_DROPDOWN_PLACEHOLDER": "Vyberte SMS schránku, z ktorej sa SMS odošle",
      "SMS_MESSAGE_INPUT_PLACEHOLDER": "Zadajte text SMS",
      "SMS_COUNTER": "{length}/{limit} znakov, {segments} SMS (pred doplnením premenných)"
    },
    "TOGGLE": {
      "ACTIVATION_TITLE": "Aktivovať automatizačné pravidlo",
      "DEACTIVATION_TITLE": "Deaktivovať automatizačné pravidlo",
      "ACTIVATION_DESCRIPTION": "Táto akcia aktivuje automatizačné pravidlo '{automationName}'. Naozaj chcete pokračovať?",
      "DEACTIVATION_DESCRIPTION": "Táto akcia deaktivuje automatizačné pravidlo '{automationName}'. Naozaj chcete pokračovať?",
      "ACTIVATION_SUCCESFUL": "Automatizačné pravidlo bolo úspešne aktivované",
      "DEACTIVATION_SUCCESFUL": "Automatizačné pravidlo bolo úspešne deaktivované",
      "ACTIVATION_ERROR": "Nepodarilo sa aktivovať automatizáciu. Skúste to prosím neskôr.",
      "DEACTIVATION_ERROR": "Nepodarilo sa deaktivovať automatizáciu. Skúste to prosím neskôr.",
      "CONFIRMATION_LABEL": "Áno",
      "CANCEL_LABEL": "Nie"
    },
    "ATTACHMENT": {
      "UPLOAD_ERROR": "Nepodarilo sa nahrať prílohu. Skúste to prosím znova.",
      "LABEL_IDLE": "Nahrať prílohu",
      "LABEL_UPLOADING": "Nahrávanie...",
      "LABEL_UPLOADED": "Úspešne nahrané",
      "LABEL_UPLOAD_FAILED": "Nahrávanie zlyhalo"
    },
    "ATTRIBUTES": {
      "EXTENSION": "Volaná klapka",
      "AI_FILTER": "AI filter",
      "MESSAGE_TYPE": "Typ správy",
      "MESSAGE_CONTAINS": "Obsah správy",
      "EMAIL": "Email kontaktu",
      "INBOX": "Schránka",
      "CHANNEL_TYPE": "Druh schránky",
      "CONVERSATION_LANGUAGE": "Jazyk konverzácie",
      "PHONE_NUMBER": "Telefónne číslo",
      "STATUS": "Stav",
      "BROWSER_LANGUAGE": "Jazyk prehliadača",
      "MAIL_SUBJECT": "Predmet emailu",
      "COUNTRY_NAME": "Krajina",
      "MARKETPLACE_COUNTRY": "Krajina marketplace",
      "REFERER_LINK": "Odkaz odkazovača",
      "ASSIGNEE_NAME": "Meno priradenia",
      "TEAM_NAME": "Názov tímu",
      "PRIORITY": "Priorita",
      "CALL_DIRECTION": "Smer hovoru",
      "MISSED_CALL": "Zmeškaný hovor",
      "MISSED_CALL_COUNT": "Počet zmeškaných hovorov",
      "MESSAGE_SOURCE_TYPE": "Typ zdroja správy",
      "INCOMING_MESSAGE_COUNT": "Počet prichádzajúcich správ",
      "OUTGOING_MESSAGE_COUNT": "Počet odchádzajúcich správ",
      "LABEL": "Štítok",
      "EMAIL_RECIPIENTS": "Príjemca e-mailu",
      "EMAIL_AUTO_REPLY": "E-mail je automatická odpoveď",
      "ATTACHMENT_EXTENSION": "Prípona prílohy",
      "WORKING_HOURS": "V pracovnom čase",
      "AGENT_REPLIED": "Agent odpovedal od zmeny stavu"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "Kľúč atribútu je povinný",
      "FILTER_OPERATOR_REQUIRED": "Operátor filtra je povinný",
      "VALUE_REQUIRED": "Hodnota je povinná",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "Value must be between 1 and 998",
      "ACTION_PARAMETERS_REQUIRED": "Parametre akcie sú povinné",
      "ATLEAST_ONE_CONDITION_REQUIRED": "Vyžaduje sa aspoň jedna podmienka",
      "ATLEAST_ONE_ACTION_REQUIRED": "Vyžaduje sa aspoň jedna akcia",
      "VALUE_MUST_BE_BETWEEN_0_AND_998": "Hodnota musí byť medzi 0 a 998",
      "ORDER_REQUIRED": "Poradie je povinné",
      "ORDER_MUST_BE_AT_LEAST_ONE": "Poradie musí byť aspoň 1"
    },
    "NONE_OPTION": "Žiadne",
    "ACTION_NOTICES": {
      "SKIP_AUTO_PRIORITY": "Táto akcia funguje iba vtedy, keď je fáza pravidla nastavená na 'Pred označením'.",
      "SKIP_AUTO_LABELING": "Táto akcia funguje iba vtedy, keď je fáza pravidla nastavená na 'Pred označením'.",
      "MOVE_CONVERSATION_TO_INBOX": "Do e-mailovej schránky je možné presunúť iba e-mailové konverzácie a konverzácie z webového chatu, pri chate len vtedy, ak má kontakt e-mailovú adresu. Inak zostane konverzácia na mieste a namiesto toho sa pridá súkromná správa.",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Založí s kontaktom novú konverzáciu vo vybranej e-mailovej schránke, pošle mu správu e-mailom a konverzáciu označí ako vyriešenú. Stane sa to zakaždým, keď sa pravidlo spustí. Ak kontakt nemá e-mailovú adresu, nič sa neodošle a namiesto toho sa pridá súkromná poznámka.",
      "SEND_SMS_IN_NEW_CONVERSATION": "Založí s kontaktom novú konverzáciu vo vybranej SMS schránke, pošle mu správu ako SMS a konverzáciu označí ako vyriešenú. Stane sa to zakaždým, keď sa pravidlo spustí. Správa je obyčajný text bez príloh. Ak kontakt nemá telefónne číslo, nič sa neodošle a namiesto toho sa pridá súkromná poznámka."
    },
    "NOTICES": {
      "AI_PROMPT": "Každé jednotlivé vyhodnotenie je spoplatnené.",
      "INCOMING_MESSAGES_COUNT": "Toto sa vzťahuje na počet prichádzajúcich správ v konverzácii.",
      "OUTGOING_MESSAGES_COUNT": "Toto sa vzťahuje na počet odchádzajúcich správ v konverzácii."
    },
    "PHASE": {
      "BEFORE_LABELING": "Pred označením",
      "AFTER_LABELING": "Po označení"
    },
    "MESSAGE_TYPE_VALUES": {
      "INCOMING": "Prichádzajúca správa",
      "OUTGOING": "Odchádzajúca správa",
      "PRIVATE": "Súkromná poznámka",
      "AI_SUMMARY": "AI sumarizácia"
    },
    "YES_NO_VALUES": {
      "YES": "Áno",
      "NO": "Nie"
    },
    "MESSAGE_SOURCE_TYPE_VALUES": {
      "FACEBOOK_MESSENGER": "Facebook Messenger",
      "INSTAGRAM_DM": "Priama správa na Instagrame",
      "FACEBOOK_COMMENT": "Komentár na Facebooku"
    },
    "EVENTS": {
      "CONVERSATION_CREATED": "Konverzácia vytvorená",
      "CONVERSATION_UPDATED": "Konverzácia aktualizovaná",
      "MESSAGE_CREATED": "Správa vytvorená",
      "CONVERSATION_OPENED": "Konverzácia otvorená",
      "CONVERSATION_RESOLVED": "Konverzácia vyriešená",
      "PHONE_CALL_FINISHED": "Hovor ukončený"
    },
    "ACTIONS": {
      "ASSIGN_AGENT": "Priradiť agenta",
      "ASSIGN_TEAM": "Priradiť tím",
      "ADD_LABEL": "Pridať štítok",
      "REMOVE_LABEL": "Odstrániť štítok",
      "SEND_EMAIL_TO_TEAM": "Odoslať e-mail tímu",
      "SEND_EMAIL_TRANSCRIPT": "Odoslať e-mailový prepis",
      "SEND_EMAIL_TRANSCRIPT_WITH_DETAILS": "Odoslať podrobný e-mailový prepis",
      "MUTE_CONVERSATION": "Stlmiť konverzáciu",
      "SNOOZE_CONVERSATION": "Odložiť konverzáciu",
      "RESOLVE_CONVERSATION": "Vyriešiť konverzáciu",
      "OPEN_CONVERSATION": "Otvoriť konverzáciu",
      "SEND_WEBHOOK_EVENT": "Odoslať udalosť webhooku",
      "SEND_ATTACHMENT": "Odoslať prílohu",
      "SEND_MESSAGE": "Odoslať správu",
      "ADD_NOTE": "Pridať poznámku",
      "CHANGE_PRIORITY": "Zmeniť prioritu",
      "ADD_SLA": "Pridať SLA",
      "SKIP_AUTO_PRIORITY": "Preskočiť automatickú prioritu",
      "SKIP_AUTO_LABELING": "Preskočiť automatické označovanie",
      "AUTO_TRANSLATE": "Preložiť správu",
      "AUTO_TRANSLATE_CONVERSATION": "Preložiť konverzáciu",
      "MOVE_CONVERSATION_TO_INBOX": "Presunúť konverzáciu do schránky",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Odoslať správu v novej konverzácii",
      "SEND_SMS_IN_NEW_CONVERSATION": "Odoslať SMS v novej konverzácii",
      "STOP_PROCESSING_RULES": "Zastaviť spracovanie pravidiel"
    },
    "WAIT": {
      "RUN_LABEL": "Spustiť akcie",
      "INSTANT": "Pri udalosti",
      "DELAYED": "S odkladom",
      "TRIGGER_LABEL": "Čakať, kým",
      "TRIGGERS": {
        "CONVERSATION_STATUS": "Konverzácia zostáva v stave",
        "CUSTOMER_UNRESPONSIVE": "Zákazník neodpovedá agentovi",
        "AGENT_UNRESPONSIVE": "Zákazník nedostal odpoveď agenta"
      },
      "STATUS_LABEL": "Stav",
      "STATUSES": {
        "OPEN": "Otvorená",
        "PENDING": "Čakajúca",
        "SNOOZED": "Odložená",
        "RESOLVED": "Vyriešená"
      },
      "DELAY_LABEL": "Doba čakania",
      "DELAY_ERROR": "Zadajte dobu medzi 1 minútou a 30 dňami",
      "DURATION": {
        "MINUTES": "{count} min",
        "HOURS": "{count} h",
        "DAYS": "{count} d"
      },
      "EXPLANATION": {
        "CONVERSATION_STATUS": "Akcie sa spustia, keď je konverzácia v stave {status} počas {duration}. Zmena stavu predtým ich zruší. Štítky, pracovný čas a odpovede agenta sa kontrolujú na konci čakania.",
        "CUSTOMER_UNRESPONSIVE": "Akcie sa spustia, keď zákazník {duration} neodpovedal na správu agenta. Odpoveď zákazníka ich zruší, nová správa agenta spustí čakanie znova.",
        "AGENT_UNRESPONSIVE": "Akcie sa spustia, keď zákazník čaká {duration} bez odpovede agenta. Odpoveď agenta ich zruší."
      }
    }
  }
}
